import { useTheme } from 'styled-components';

import * as Styled from './Toggle.styled';

export type CustomisedToggleProps = {
  toggleOn: boolean;
  handleToggle?: any;
  requestLoading?: boolean;
  readonly?: boolean;
  width?: number;
  height?: number;
  disabled?: boolean;
};
const Toggle = ({
  toggleOn,
  handleToggle,
  requestLoading = false,
  readonly = false,
  width = 40,
  height = 20,
  disabled,
  ...props
}: CustomisedToggleProps) => {
  const {
    activeColorScheme: { colors },
  } = useTheme();

  const isDisabled = readonly || requestLoading || disabled;

  return (
    <Styled.Switch
      checked={toggleOn}
      checkedIcon={false}
      disabled={isDisabled}
      height={height}
      offColor={
        isDisabled
          ? colors.backgroundDisabledSubtle
          : colors.toggleOffBackground
      }
      uncheckedIcon={false}
      width={width}
      onChange={handleToggle}
      onColor={
        isDisabled ? colors.backgroundDisabledStrong : colors.toggleOnBackground
      }
      {...props}
    />
  );
};

export default Toggle;
